
import { storeDatatoSessionStorage } from "@/app/infrastructures/misc/SessionStorage";
import { playNotification } from "@/app/infrastructures/misc/UtilsAudio";
import { dataLayer } from "@/app/infrastructures/misc/UtilsGtm";
import { CargoController } from "@/app/ui/controllers/CargoController";
import { LocationController } from "@/app/ui/controllers/LocationController";
import {
  BagOrSttNumber,
  CalculateVolumeApiRequest,
  CalculateVolumeRequest
} from "@/data/payload/api/CargoApiRequest";
import {
  CargoData,
  CargoDetailStt,
  DimensionData,
  DimensionPerKoliDetail,
  DimensionPerKoliData,
  CargoDetailBagData,
  CargoDetailSttPiece,
  DimensionCustomData,
  CargoScanFailed,
  CargoStorageKey,
  CargoProductData,
  CalculateVolume
} from "@/domain/entities/Cargo";
import { ResponseBagSttDetail } from "@/domain/entities/ResponsePayload";
import debounce from "lodash/debounce";
import { mixins, Options } from "vue-class-component";
import { gtmCargoData } from "../../modules/gtm";
import NotificationCommodityGrouping from "@/app/ui/components/notification-commodity-group/index.vue";
import uniqBy from "lodash/uniqBy";
import capitalize from "lodash/capitalize";
import { ReadyToCargoController } from "@/app/ui/controllers/ReadyToCargoController";
import { flags } from "@/feature-flags";
import { TrackingController } from "@/app/ui/controllers/TrackingController";
import {
  checkValueOnBlurInput,
  commaDecimalToDecimal,
  formatByCountry,
  formatInputByCountry,
  parseByCountry,
  parsingErrorResponse
} from "@/app/infrastructures/misc/Utils";
import { AccountController } from "@/app/ui/controllers/AccountController";
import CargoFlightManualSection from "@/app/ui/views/cargo/booking-cargo/third-step/cargo-flight-manual-section.vue";
import { FlightDetail } from "@/domain/entities/NGen";
import { NGenController } from "@/app/ui/controllers/NGenController";
import { OptionsClass, UploadMultiple } from "@/domain/entities/MainApp";
import { defineAsyncComponent } from "@vue/runtime-core";
import isFormatLiloBag from "@/app/infrastructures/misc/common-library/isFormatLiloBag";
import { FlagsPermissionCargo } from "@/feature-flags/flags-permission-cargo";
import CargoPlaneAutoV2 from "../v2/CargoPlaneAutoV2";
const Gamification = defineAsyncComponent(() =>
  import(
    "@/app/ui/views/cargo/booking-cargo/components/gamification-rtc-modal/index.vue"
  )
);
import DimensionPerKoli from "./dimension-per-koli.vue";
import { getDataSessionStorage } from "@/app/infrastructures/misc/Utils";
import ScanFailedCard from "../../component/scan-failed-card/index.vue";
import SectionUploadPhotoForWeightAdjusment from "../../component/section-upload-photo-for-weight-adjustment/index.vue";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import {
  DeleteHydraFileRequest,
  UploadHydraFileRequest
} from "@/data/payload/api/BookingRequest";
import { BookingController } from "@/app/ui/controllers/BookingController";
import WeightSummaryStt from "./weight-summary-stt.vue";
import WeightSummaryTimbangUlang from "./weight-summary-timbang-ulang.vue";
import {
  getConfigDimensionDivider,
  CALCULATE_TYPE,
  getConfigIsminimumVolumePerPiece,
  getConfigMinimumVolumePerPiece
} from "../../modules/cargo-module";
import { useCargo } from "../composables/cargo";

const { checkEligible } = useCargo();

@Options({
  emits: ["dataChange", "leave-page"],
  components: {
    NotificationCommodityGrouping,
    CargoFlightManualSection,
    Gamification,
    DimensionPerKoli,
    ScanFailedCard,
    SectionUploadPhotoForWeightAdjusment,
    WeightSummaryStt,
    WeightSummaryTimbangUlang
  },
  watch: {
    "form.photoProof": {
      handler(newVal) {
        if (Array.isArray(newVal) && newVal.length > 0) {
          this.rebookingTempPhotoProof = newVal;
        }
      },
      deep: true
    }
  }
})
export default class FormSection extends mixins(CargoPlaneAutoV2) {
  get countryCode() {
    return AccountController.accountData?.countryCode ?? "ID";
  }

  notificationTimeout?: NodeJS.Timeout = undefined;
  openAdjustmentWeight = true;
  isGrossWeightChanged = false;
  loadingFirstLanding = true;
  rebookingTempPhotoProof = [];
  isDeletedIneligible = false;

  updated() {
    if (this.form.cargoTypeStatus !== "auto")
      CargoController.setIsCargoDimensionOn(false);
  }

  async mounted() {
    this.loadingFirstLanding = true;

    if (!this.form.isChangeAirport) {
      if (this.flowBooking == "rtc-edit") {
        this.mappingReadyToCargo();
      }
      if (
        this.$route.query.rcId &&
        this.isEmptyRcId &&
        !CargoController.isDeleteStt
      ) {
        await CargoController.getDetailRetryCargo({
          cargoNo: this.$route.query.rcId.toString(),
          isPrint: false
        });
        this.mappingSttResultFromDetail();
        this.onUpdateLocalStorageRebooking();
      }
      if (this.$route.query.rcId) {
        await this.$nextTick();
        await this.checkEligible();
        await this.$nextTick();
        this.calculateVolume(CargoController.calculateType);
      }
      this.setVolumeWeight();
      this.resetBaggingGroupingAndDate();
      if (this.sttResult.length) this.autoFillDestination(this.sttResult[0]);
    }
    this.updateEstimationVolumeAndWeight();
    this.getCargoProductList();
    this.onSetCommodityGroup(true);

    CargoController.setTotalPcs(CargoController.totalSttPieces);

    // if (this.flowBooking === "rtc-edit" || this.isCutoffPlaneRTC) {
    //   CargoController.calculationVolumeWeight(this.totalPcs);
    // }

    if (this.cargoInputForm.totalActualCargoColi != 0) {
      CargoController.setTotalPcs(
        CargoController.cargoInputForm.totalActualCargoColi
      );
    }

    if (
      this.isFromRebookingRTC &&
      this.dataDetailRetryCargo.cargoActualPiece &&
      !this.isDeletedIneligible
    ) {
      CargoController.setTotalPcs(this.dataDetailRetryCargo.cargoActualPiece);
    }

    this.form.actualTotalSTTPieces = this.totalPcs;

    if (this.IS_EDIT_RTC) {
      this.updateDimensionPerKoliData();
      await this.$nextTick();
      await this.$nextTick();
      CargoController.setOnChangeTotalCargoVolumeWeight(
        this.parseNumber(this.form.actualTotalCargoVolumeWeight) ||
          this.totalNewCalculationVolumeWeights
      );
      await this.$nextTick();
      CargoController.setEstimationTotalGrossWeight(
        this.totalNewCalculationGrossWeights
      );
      CargoController.setEstimationTotalVolumeWeight(
        Math.round(this.totalNewCalculationVolumeWeights)
      );
      this.form.estTotalCargoGrossWeight = this.convertDecimal(
        this.totalNewCalculationGrossWeights
      );
      this.form.estTotalCargoVolumeWeight = this.convertDecimal(
        Math.round(this.totalNewCalculationVolumeWeights)
      );
      this.calculateVolume(CargoController.calculateType);
    } else if (!this.isRebooking) {
      CargoController.setCargoType("");
      await this.$nextTick();
    }

    window.addEventListener("deletecargostt", () => {
      this.onSetCommodityGroup();
    });

    this.setCargoFailedScanFromStorage();

    if (this.isRebooking) {
      this.form.photoProof = this.cargoInputForm.photoProof;
    }

    this.loadingFirstLanding = false;

    if (!this.form.cargoType) {
      this.calculateVolume(CargoController.calculateType);
    }
  }

  get isRebooking() {
    return this.flowBooking === "rebooking";
  }

  get chargeableWeight() {
    return Math.max(
      1,
      this.parseNumber(String(this.totalNewCalculationGrossWeights)),
      this.parseNumber(String(this.totalNewCalculationVolumeWeights))
    );
  }

  get actualChargeableWeight() {
    return CargoController.calculateVolumeData.chargeableWeight;
  }

  unmounted() {
    window.removeEventListener("deletecargostt", () => {
      this.onSetCommodityGroup();
    });
  }

  get isCutoffPlaneRTC() {
    return (
      this.flowBooking === "rtc-process" &&
      !this.detailRTC.cutOffTime &&
      this.detailRTC.cargoType === "plane"
    );
  }

  get cargoInputFormData() {
    return CargoController.cargoInputForm;
  }

  get detailRTC() {
    return ReadyToCargoController.readyToCargoDetail;
  }

  get flowBooking() {
    return ReadyToCargoController.flowBooking;
  }

  get isEmptyRcId() {
    return this.cargoInputForm.id === 0 || !this.cargoInputForm?.id;
  }

  onResetAirport() {
    this.form.airports = [];
  }

  get dataDetailRetryCargo() {
    return CargoController.cargoDetailData;
  }

  // destination city
  get destinationCity() {
    return CargoController.destinationCity;
  }

  fetchDestinationCity = debounce((search: string) => {
    LocationController.getCityList({
      search: search,
      status: "",
      page: 1,
      limit: 10
    });
  }, 250);

  showInfoDividerCargo = true;

  get form() {
    return CargoController.form;
  }

  get isLoadingCity() {
    return LocationController.isLoadingDestinationCity;
  }

  get optionDestinationCity() {
    return CargoController.optionDestinationCity;
  }

  get Dimension() {
    return CargoController.CargoInputData.dimension;
  }

  get totalGrossWeights() {
    return CargoController.totalGrossWeights || "0";
  }

  get totalNewCalculationGrossWeights() {
    return CargoController.totalNewCalculationGrossWeights;
  }

  get totalNewCalculationVolumeWeights() {
    return CargoController.totalNewCalculationVolumeWeights;
  }

  get totalVolumeWeights() {
    return CargoController.totalVolumeWeights;
  }

  get isDimensionChanged() {
    return CargoController.isDimensionChanged;
  }

  changeDestinationCity(item: any) {
    this.form.destinationCityCode = item.code;
    this.form.destinationCityName = item.name;
    this.getBaggingGroupingLocation(this.form.destinationCityCode);
    CargoController.setDestinationCity(item);
    this.$emit("dataChange");
  }

  public setPeriodeStart(date: Date) {
    const estDepartureDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
    const estArrivalDate = this.$moment(date)
      .add(6, "days")
      .toISOString();
    this.form.estDepartureDate = estDepartureDate;
    this.form.estArrivalDate = estArrivalDate;

    const cargoInputForm = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );
    cargoInputForm.estDepartureDate = estDepartureDate;
    cargoInputForm.estArrivalDate = estArrivalDate;
    storeDatatoSessionStorage("cargo-input-data", cargoInputForm);
  }

  get isDisableAddSttNumber() {
    return !this.scanNumber;
  }

  convertProduct(name: string) {
    return name;
  }

  totalPiecesBagOrStt = 0;

  async addSttNumberToUpdate() {
    const isCheckTrackingSttFirst = !this.checkSttorBagFormatNumber(
      this.sttNumber.trim()
    ); // this is for checking if it need to use tracking stt endpoint or not

    const isSttFromLilo = this.checkSttFromLilo(this.sttNumber.trim());

    const inputStt = this.sttNumber;
    let generatedStt = this.scanNumber.trim();

    if (isCheckTrackingSttFirst && !isSttFromLilo) {
      await TrackingController.trackStt({
        sttNo: this.sttNumber.trim(),
        isGetSla: false,
        isSecondCall: false,
        cache: true
      }).then((isSuccess) => {
        if (isSuccess) {
          this.sttNumber = this.sttDetail.sttNo;
          generatedStt = this.sttDetail.sttNo;
        }
      });
    }

    let bagNumber = "";
    let sttNumber = "";
    const isSttOrBag = /^\d/.test(this.sttNumber);

    if (!isSttOrBag) {
      0;
      bagNumber = this.sttNumber.trim();
    } else {
      sttNumber = this.sttNumber.trim();
    }

    await CargoController.appendBagOrSttNumber({
      bagOrStt: new BagOrSttNumber(bagNumber, sttNumber),
      cargoProductType: this.convertProduct(this.form.cargoProduct),
      cargoCommodity: this.form.cargoCommodityCode ?? "",
      cargoType: this.form.cargoType,
      callback: this.addStt,
      storageKey: this.cargoFailedScanStorageKey
    }).then(() => {
      if (isCheckTrackingSttFirst && !isSttFromLilo) {
        this.sttResult.map((item) => {
          if (item.sttNumber.toLowerCase() == generatedStt.toLowerCase()) {
            item.sttNoRefExternal = inputStt.trim();
          }
          return item;
        });
      }
      return;
    });
    CargoController.resetTotalColiOnLocalStorage();
    this.onSetCommodityGroup();
    this.onChangeTotalColi(CargoController.totalSttPieces);
    // CargoController.calculationVolumeWeight(this.totalPcs);
    CargoController.setIsModalGamificationDone(true);
  }

  sttNumber = "";
  scanNumber = "";
  isScan = false;

  checkSttorBagFormatNumber(value: string) {
    const sttPatern = /^\d{2}[a-z]{2}/; // check for stt number
    const bagPattern = /^[a-z]{3}-\d+$/; // check for bag number
    return (
      sttPatern.test(value.toLocaleLowerCase()) ||
      bagPattern.test(value.toLocaleLowerCase())
    );
  }

  checkSttFromLilo(value: string) {
    return isFormatLiloBag(value);
  }

  addScanSttNumber(val: any) {
    if (!this.isDisableAddSttNumber) {
      const splitVal = val.split("#");
      this.sttNumber = `${splitVal[0]}`;
      this.isScan = true;
      this.blurInputStt();
      this.sttNumber && this.addSttNumberToUpdate();
    }
  }

  blurInputStt() {
    const inputStt: any = this.$refs.inputStt;
    inputStt?.blur();
  }

  addSttNumber() {
    if (!this.isDisableAddSttNumber) {
      this.isScan = false;
      const splitVal = this.scanNumber.split("#");
      this.sttNumber = `${splitVal[0]}`;
      this.blurInputStt();
      this.sttNumber && this.addSttNumberToUpdate();
    }
  }

  get errorTypeAppend(): string {
    return CargoController.errorCauseAppend;
  }

  addStt(fetchBagOrStt: any) {
    this.isErrorNotification = false;
    this.errorSttNumber = "";

    if (fetchBagOrStt || this.errorTypeAppend === "server") {
      const detailSTT = CargoController.bagSttDetail;
      const bagOrStt = detailSTT.bagOrStt || [];

      const checkErrorSttNeedAssessment = bagOrStt.find((item: any) =>
        ["waiting", "rejected"].includes(item.stt_assessment_status)
      );

      if (checkErrorSttNeedAssessment) {
        playNotification("error");
        this.errorSttNumber =
          "Gagal scan karena adjustment STT belum disetujui tim Lion Parcel, tunggu dihubungi CS.";
        this.messageErrorNotification =
          "Adjustment STT belum disetujui tim Lion Parcel, tunggu follow up dari CS.";

        for (const detail of detailSTT.bagOrStt) {
          this.onFailedAddStt(detail);
        }

        this.addToScanFailedList(
          new CargoScanFailed({
            sttNumber: this.sttNumber,
            lastStatus: detailSTT.lastStatus,
            failureReason: this.errorSttNumber
          })
        );

        clearTimeout(this.notificationTimeout as NodeJS.Timeout);
        this.notificationTimeout = setTimeout(() => {
          this.notification = false;
          this.notificationCommodityGrouping = false;
        }, 15000);
      } else if (detailSTT.isAllowUpdateStatus) {
        this.onProcessCargoData(detailSTT);
      } else {
        playNotification("error");
        this.errorSttNumber = detailSTT.errorMessage;

        this.addToScanFailedList(
          new CargoScanFailed({
            sttNumber: this.sttNumber,
            lastStatus: detailSTT.lastStatus,
            failureReason: this.errorSttNumber
          })
        );
      }
    }
  }

  // handle stt number
  errorSttNumber = "";
  isValidateScan = false;
  isErrorValidationScan = false;
  isUnpaid = false;
  isErrorNotification = false;

  savedSttNo = "";
  savedCargoType = "";
  savedCargoNumber = "";

  async onProcessCargoData(detailSTT: any) {
    const existingBagNo = this.sttResult.some((data: CargoDetailStt) =>
      detailSTT.bagOrStt.some((detail: any) => detail.stt_no === data.sttNumber)
    );
    if (existingBagNo) {
      this.onScanAlreadyInput();
      return;
    }

    for (const [index, detail] of detailSTT.bagOrStt.entries()) {
      this.onValidateSttResult(detailSTT, detail, index);
      if (this.isValidateScan) {
        this.detailSttNotification = {
          sttNumber: detail.stt_no,
          product: detail.product_type,
          commodity: detail.commodity_name,
          totalPieces: detail.stt_total_piece,
          destinationCity: this.destinationCity?.name,
          commodityGroupName: detail.commodity_group_name
        };
        this.detailNotificationCommodityGrouping = {
          sttCommodityGroupName: detail.commodity_group_name,
          message: this.$t("Komoditas kargo tidak sama")
        };

        // GTM
        if (this.form.cargoType && this.form.cargoType !== "ship") {
          const gtmInputSttSuccess = gtmCargoData({
            type: this.form.cargoType,
            isAuto: this.isPlaneAuto
          }).inputSttSuccess;

          dataLayer(
            gtmInputSttSuccess.eventName,
            gtmInputSttSuccess.property,
            []
          );
        }
        this.onValidateCommodityGrouping(detail);
      }
    }
    if (this.isValidateScan && !this.isUnpaid) {
      const getGrossWeight =
        detailSTT.bagOrStt[0].bag_data.bag_custom_gross_weight ??
        detailSTT.bagOrStt[0].gross_weight;
      const totalActualGrossWeight =
        this.cargoInputForm.calcuateActualCargoGrossWeight + getGrossWeight; // explanation https://github.com/Lionparcel/medusa/pull/5753/files#r1285584448
      CargoController.setTotalActualGrossWeight(
        totalActualGrossWeight.toFixed(2)
      );
      this.updateEstimationVolumeAndWeight();
      await this.$nextTick();
      this.form.actualTotalSTTPieces = CargoController.totalSttPieces;
      CargoController.setOnChangeTotalActualGrossWeight(
        this.totalNewCalculationGrossWeights
      );
      CargoController.setEstimationTotalGrossWeight(
        this.totalNewCalculationGrossWeights
      );
      CargoController.setEstimationTotalVolumeWeight(
        Math.round(this.totalNewCalculationVolumeWeights)
      );
      this.form.estTotalCargoGrossWeight = this.convertDecimal(
        this.totalNewCalculationGrossWeights
      );
      this.form.estTotalCargoVolumeWeight = this.convertDecimal(
        Math.round(this.totalNewCalculationVolumeWeights)
      );
      this.calculateVolume(CALCULATE_TYPE.INIT, true);
    }
    this.onSuccessAddStt();
  }

  onValidateSttResult(detailSTT: any, detail: any, index: number) {
    const isScanBag = !/^\d/.test(this.sttNumber);
    const indexCurrentSttNumber = this.sttResult.findIndex((data) => {
      return data.sttNumber === detail.stt_no;
    });

    if (indexCurrentSttNumber > -1) {
      this.addToScanFailedList(
        new CargoScanFailed({
          sttNumber: this.sttNumber,
          success: true
        })
      );

      if (this.sttResult[indexCurrentSttNumber].action === "remove") {
        this.sttResult[indexCurrentSttNumber].action = "";
      } else {
        this.onScanAlreadyInput();
        return;
      }
    } else if (!detail.is_paid) {
      this.isUnpaid = true;
      this.isErrorNotification = true;
      this.messageErrorNotification =
        "Tunggu sampai customers selesai melunasi tagihan kurang bayar";
      this.errorSttNumber =
        "Terjadi kelebihan berat sehingga status tidak dapat diupdate ke Cargo.";
      playNotification("error");

      this.addToScanFailedList(
        new CargoScanFailed({
          sttNumber: this.sttNumber,
          lastStatus: detailSTT.lastStatus,
          failureReason: this.errorSttNumber
        })
      );
    } else {
      if (isScanBag) {
        this.appendBagResult(
          detailSTT.bagOrStt[0]?.bag_no || detailSTT.bagOrStt[0]?.bag_vendor_no,
          detailSTT
        );
      }
      this.isCacheCommodityGroup = false;
      this.sttResult.push(
        new CargoDetailStt({
          baggingNumber: detail.bag_no,
          baggingVendorNo: detail.bag_vendor_no,
          sttNumber: detail.stt_no,
          totalPieces: detail.stt_total_piece,
          grossWeigth: detail.gross_weight,
          volumeWeight: detail.volume_weight,
          productType: detail.product_type,
          commodity: detail.commodity_name,
          commodityGroupCode: detail.commodity_group_code,
          commodityGroupName: detail.commodity_group_name,
          commodityGroupIsDg: detail.commodity_group_is_dg,
          destinationCityCode: detail.destination_city_code,
          regionId: detail.region_id,
          shcCode: detail.shc_code,
          shcName: detail.shc_description,
          bagData: new CargoDetailBagData({
            bagCustomGrossWeight: detail?.bag_data?.bag_custom_gross_weight,
            bagGrossWeight: detail?.bag_data?.bag_gross_weight,
            bagCustomLength: detail?.bag_data?.bag_custom_length,
            bagCustomWidth: detail?.bag_data?.bag_custom_width,
            bagCustomHeight: detail?.bag_data?.bag_custom_height,
            bagTotalChargeableWeight:
              detail?.bag_data?.bag_total_chargeable_weight,
            bagCustomChargeableWeight:
              detail?.bag_data?.bag_custom_chargeable_weight,
            totalSttChargeableWeight:
              detail?.bag_data?.total_stt_chargeable_weight,
            isUseNewCalculation: detail?.bag_data?.is_use_new_calculation,
            bagCustomVolumeWeight:
              detail?.bag_data?.bag_custom_volume_weight || 0,
            totalSttGrossWeight: detail?.bag_data?.total_stt_gross_weight || 0,
            totalSttVolumeWeight: detail?.bag_data?.total_stt_volume_weight || 0
          }),
          sttPieces: detail?.stt_pieces?.map(
            (item: any) =>
              new CargoDetailSttPiece({
                sttPieceLength: item?.stt_piece_length,
                sttPieceWidth: item?.stt_piece_width,
                sttPieceHeight: item?.stt_piece_height,
                sttPieceGrossWeight: item?.stt_piece_gross_weight,
                sttPieceVolumeWeight: item?.stt_piece_volume_weight
              })
          ),
          bagCustomChargeableWeight:
            detail?.bag_data?.bag_custom_chargeable_weight,
          bagTotalChargeableWeight:
            detail?.bag_data?.bag_total_chargeable_weight,
          chargeableWeight: detail?.chargeable_weight,
          totalSttChargeableWeight:
            detail?.bag_data?.total_stt_chargeable_weight ||
            detail?.chargeable_weight,
          sttClientId: detail?.stt_client_id
        })
      );

      if (detail.region_id) {
        this.autoFillDestination(detail);
      }
      this.$emit("dataChange");
      playNotification("success");

      this.addToScanFailedList(
        new CargoScanFailed({
          sttNumber: this.sttNumber,
          success: true
        })
      );

      // update dimension per koli
      this.updateDimensionPerKoliData();

      CargoController.setIsSttUpdated(CargoController.isDimensionSaved);
    }
    this.isValidateScan = true;
  }
  onScanAlreadyInput() {
    playNotification("error");
    this.errorSttNumber = this.$t("No. STT sudah di input");
    this.isValidateScan = false;
  }
  onValidateCommodityGrouping(detail: any) {
    const res = isNaN(+this.actualTotalCargoGrossWeight)
      ? parseByCountry(this.actualTotalCargoGrossWeight, { country: this.countryCode }) < 10
      : +this.actualTotalCargoGrossWeight < 10;
    this.setShowNotificationWeight(res && !this.isErrorNotification);
    if (this.sttResult.length > 1 && !this.isErrorNotification) {
      if (
        this.sttResult[0].commodityGroupCode !== detail.commodity_group_code
      ) {
        this.detailNotificationCommodityGrouping = {
          sttCommodityGroupName: this.sttResult[0].commodityGroupName,
          message: this.$t("Komoditas kargo tidak sama")
        };
        this.notificationCommodityGrouping = true;
      } else {
        this.notificationCommodityGrouping = false;
      }
    }
  }
  onSuccessAddStt() {
    // reset form
    this.savedSttNo = this.sttNumber;
    this.scanNumber = "";
    this.notification = this.isValidateScan;

    if (!this.isErrorValidationScan) {
      this.isValidateScan = false;
    }
    // re focus
    const inputStt: any = this.$refs.inputStt;
    inputStt.focus();

    // remove notification after 15 second
    if (!this.isUnpaid) {
      clearTimeout(this.notificationTimeout as NodeJS.Timeout);
      this.notificationTimeout = setTimeout(() => {
        this.notification = false;
        this.notificationCommodityGrouping = false;
      }, 15000);
    }
  }

  onFailedAddStt(detailSTT: any) {
    this.detailSttNotification = {
      sttNumber: detailSTT.stt_no,
      destinationCity: `${detailSTT.destination_city_code} - ${detailSTT.destination_city_name}`
    };
    this.isErrorNotification = true;
    this.notification = true;
  }

  get scanFailedList(): CargoScanFailed[] {
    return CargoController.scanFailedList;
  }
  addToScanFailedList(data: CargoScanFailed) {
    CargoController.addScanFailedList(
      new CargoScanFailed({
        ...data,
        storageKey: this.cargoFailedScanStorageKey
      })
    );
  }
  get cargoFailedScanStorageKey(): string {
    if (this.flowBooking === "rebooking")
      return CargoStorageKey.FailedListRetryBooking;

    if (this.isRTC) return CargoStorageKey.FailedListEditRtc;

    return CargoStorageKey.FailedListNonRtc;
  }
  setCargoFailedScanFromStorage() {
    CargoController.setScanFailedListFromStorage(
      this.cargoFailedScanStorageKey
    );
  }

  // notification handler
  notification = false;
  detailSttNotification: any = null;
  notificationCommodityGrouping = false;
  detailNotificationCommodityGrouping: any = null;
  messageErrorNotification = "";

  onCloseNotification() {
    this.isUnpaid = false;
    this.isErrorNotification = false;
    this.isDiffDestination = false;
    this.errorSttNumber = "";
    this.notification = false;
  }

  appendBagResult(bagNo: string, detailSTT: ResponseBagSttDetail) {
    if (!this.bagResult.find((item) => item.baggingNumber === bagNo)) {
      this.bagResult.push({
        baggingNumber: bagNo,
        bagGrossWeight: detailSTT.bagOrStt[0].bag_data.bag_custom_gross_weight,
        stt: detailSTT.bagOrStt.map(
          (item: any) =>
            new CargoDetailStt({
              baggingNumber: item.bag_no,
              baggingVendorNo: item.bag_vendor_no,
              sttNumber: item.stt_no,
              totalPieces: item.stt_total_piece,
              grossWeigth: item.gross_weight,
              volumeWeight: item.volume_weight,
              productType: item.product_type,
              commodity: item.commodity_name,
              commodityGroupCode: item.commodity_group_code,
              commodityGroupName: item.commodity_group_name
            })
        )
      });
      CargoController.setBagResult(this.bagResult);
    }
  }

  get sttDetail() {
    return TrackingController.trackingSttData.sttDetail;
  }

  get bagResult(): {
    baggingNumber: string;
    bagGrossWeight: number;
    stt: CargoDetailStt[];
  }[] {
    storeDatatoSessionStorage("cargo-bag", CargoController.bagResult);
    return CargoController.bagResult;
  }

  get sttResult(): CargoDetailStt[] {
    storeDatatoSessionStorage(
      "cargo",
      CargoController.sourceSttFromLocalStorage
    );
    return CargoController.sourceSttFromLocalStorage;
  }

  set sttResult(newSttResult: CargoDetailStt[]) {
    storeDatatoSessionStorage("cargo", newSttResult);
    CargoController.setSourceFromLocalStorage(newSttResult);
  }

  maxTotalBagOrSttForPlane = false;

  get sttResultFinal() {
    const tempData: any = [];
    if (this.sttResult) {
      this.sttResult.forEach((e: any) => {
        const existingIdx = tempData.findIndex(
          (a: any) => a.baggingNumber === e.baggingNumber
        );
        if (e.baggingNumber && !e.sttDetails) {
          if (existingIdx > -1) {
            tempData[existingIdx]["sttDetails"].push(e);
          } else {
            tempData.push({ ...e, sttDetails: [e] });
          }
          return;
        }
        tempData.push(e);
      });
    }
    CargoController.setSTTResultFinal(tempData);
    return tempData;
  }

  // airport
  get isPlaneAuto() {
    return (
      this.form.cargoType === "plane" && this.form.cargoTypeStatus === "auto"
    );
  }

  get actualTotalCargoGrossWeight() {
    let total = CargoController.CargoInputData.totalActualCargoGrossWeight;
    if (CargoController.isEditReadyToCargo) {
      total = ReadyToCargoController.readyToCargoDetail.totalWeight;
    }
    if (CargoController.CargoInputData.totalActualCargoGrossWeight) {
      total = CargoController.CargoInputData.totalActualCargoGrossWeight;
    }
    this.form["actualTotalCargoGrossWeight"] = String(total);
    return String(total);
  }

  set actualTotalCargoGrossWeight(str: string) {
    this.form.actualTotalCargoGrossWeight = str;
  }

  calculationVolumeWeight() {
    CargoController.calculationVolumeWeight(this.totalPcs);
  }

  setVolumeWeight() {
    if (this.flowBooking == "manual") {
      this.form.actualDimension = {
        length: this.cargoInputFormData.dimension.length || 90,
        width: this.cargoInputFormData.dimension.width || 60,
        height: this.cargoInputFormData.dimension.height || 0
      };
    } else {
      this.form.actualDimension = {
        length: this.form.actualDimension.length || 90,
        width: this.form.actualDimension.width || 90,
        height: this.form.actualDimension.height || 0
      };
      this.cargoInputForm.dimension = this.form.actualDimension;
    }
  }

  get cargoInputForm() {
    return CargoController.cargoInputForm;
  }

  set actualTotalSTTPieces(value: number) {
    this.form.actualTotalSTTPieces = value;
  }

  get totalPieces() {
    return CargoController.totalSttPieces;
  }

  get totalPcs() {
    return CargoController.totalPcs;
  }

  // set totalPcs(num: number) {
  //   this.form.actualTotalSTTPieces = num;
  //   CargoController.setOnChangeTotalColi(this.form.actualTotalSTTPieces);
  // }

  formatNoDecimal(value: string) {
    return formatInputByCountry(value, { type: "quantity", country: this.countryCode });
  }

  formatFloat(value: string) {
    return formatInputByCountry(value, { type: "weight", country: this.countryCode });
  }

  formatDimension(value: string) {
    return formatInputByCountry(value, { type: "dimension", country: this.countryCode });
  }

  formatValue(value: string, type: string) {
    if (checkValueOnBlurInput(value) === "withoutComma") {
      const newValue = formatByCountry(Number(value), { type: "weight", country: this.countryCode });
      if (type === "grossWeight") {
        CargoController.CargoInputData.totalActualCargoGrossWeight = newValue;
        this.form.actualTotalCargoGrossWeight = newValue;
        this.cargoInputForm.totalActualCargoGrossWeight = newValue;
      } else {
        this.form.actualTotalCargoVolumeWeight = newValue;
        this.cargoInputForm.totalActualCargoVolumeWeight = newValue;
      }
      storeDatatoSessionStorage("cargo-input-data", this.cargoInputForm);
    } else if (checkValueOnBlurInput(value) === "oneValueAfterComma") {
      if (type === "grossWeight") {
        CargoController.CargoInputData.totalActualCargoGrossWeight =
          value + "0";
        this.form.actualTotalCargoGrossWeight = value + "0";
        this.cargoInputForm.totalActualCargoGrossWeight = value + "0";
      } else {
        this.form.actualTotalCargoVolumeWeight = value + "0";
        this.cargoInputForm.totalActualCargoVolumeWeight = value + "0";
      }
      storeDatatoSessionStorage("cargo-input-data", this.cargoInputForm);
    } else if (checkValueOnBlurInput(value) === "minimumValue") {
      const sep = this.countryCode === "MY" ? "." : ",";
      const newValueMinimum = value.split(sep)[0];
      const zeroTen = this.countryCode === "MY" ? ".10" : ",10";
      if (type === "grossWeight") {
        CargoController.CargoInputData.totalActualCargoGrossWeight =
          newValueMinimum + zeroTen;
        this.form.actualTotalCargoGrossWeight = newValueMinimum + zeroTen;
        this.cargoInputForm.totalActualCargoGrossWeight =
          newValueMinimum + zeroTen;
      } else {
        this.form.actualTotalCargoVolumeWeight = newValueMinimum + zeroTen;
        this.cargoInputForm.totalActualCargoVolumeWeight =
          newValueMinimum + zeroTen;
      }
      storeDatatoSessionStorage("cargo-input-data", this.cargoInputForm);
    }
  }

  isDiffDestination = false;

  getBaggingGroupingLocation(code: string) {
    return CargoController.getRegionBaggingGrouping(code);
  }

  setShowNotesDestination(bool: boolean) {
    CargoController.setShowNotesDestination(bool);
  }

  get regionBaggingGrouping() {
    return CargoController.regionBaggingGrouping;
  }

  get showNotesDestination() {
    return CargoController.showNotesDestination;
  }

  get loadingRegion() {
    return CargoController.loadingRegion;
  }

  get dataProfile() {
    return CargoController.dataProfile;
  }

  get showRecommendationRegion() {
    return (
      this.form.destinationCityCode &&
      !this.loadingRegion &&
      this.showNotesDestination &&
      this.regionBaggingGrouping.baggingRegionDestinationId &&
      this.regionBaggingGrouping.baggingRegionDestinationName &&
      this.form.destinationCityCode !==
        this.regionBaggingGrouping.baggingRegionDestinationId &&
      this.dataProfile.account_location.city_code !==
        this.regionBaggingGrouping.baggingRegionDestinationId &&
      this.regionBaggingGrouping.baggingRegionOriginId !==
        this.regionBaggingGrouping.baggingRegionDestinationId
    );
  }

  autoFillDestination(detailSTT: any) {
    CargoController.autoFillDestination(detailSTT);
  }

  get showNotificationWeight() {
    return CargoController.showNotificationWeight;
  }

  setShowNotificationWeight(val: boolean) {
    CargoController.setNotificationWeight(val);
  }

  async mappingSttResultFromDetail() {
    const destinationParam = new OptionsClass({
      code: this.dataDetailRetryCargo.destinationCityCode,
      label: `${this.dataDetailRetryCargo.destinationCityCode} - ${capitalize(
        this.dataDetailRetryCargo.destinationCityName.toLowerCase()
      )}`,
      name: this.dataDetailRetryCargo.destinationCityName
    });
    this.form.actualDimension =
      this.dataDetailRetryCargo.actualDimension || new DimensionData();
    this.form.actualTotalCargoVolumeWeight = this.dataDetailRetryCargo.totalActualCargoVolumeWeight;

    if (this.$route.query.rcId) {
      CargoController.setTotalActualGrossWeight(
        parseByCountry(
          this.dataDetailRetryCargo.totalActualCargoGrossWeight.toString(),
          { country: this.countryCode }
        )
      );
      this.form.nog = this.dataDetailRetryCargo.nog || "";
      this.form.cargoProduct = this.dataDetailRetryCargo.cargoProduct;
      this.form.vehicleNumber = this.dataDetailRetryCargo.vehiclePoliceNumber;
      CargoController.setCargoType({ type: "plane", status: "auto" });
      this.form.shcCode = this.dataDetailRetryCargo.shcCode;
      this.form.shcName = this.dataDetailRetryCargo.shcDescription;
      this.form.cargoCommodityCode = this.dataDetailRetryCargo.cargoCommodityCode;
      this.form.cargoCommodityName = this.dataDetailRetryCargo.cargoCommodity;
      CargoController.setIsFromRebookingRTC(
        this.dataDetailRetryCargo.isFromRtc
      );
      const newSttResult: CargoDetailStt[] = [];
      this.dataDetailRetryCargo.detailStt.forEach((detail: CargoDetailStt) => {
        const bagData = this.dataDetailRetryCargo.cargoDimensionCustom.find(
          (e) => e.sttOrBag === detail.baggingNumber
        );

        newSttResult.push(
          new CargoDetailStt({
            baggingNumber: detail.baggingNumber,
            sttNumber: detail.sttNumber,
            totalPieces: detail.totalPieces,
            grossWeigth: detail.grossWeigth,
            volumeWeight: detail.volumeWeight,
            productType: detail.productType,
            commodity: detail.commodity,
            destination: detail.destination,
            destinationCityCode: detail.destinationCityCode,
            destinationCityName: detail.destinationCityName,
            regionId: detail.regionId,
            commodityGroupCode: detail.commodityGroupCode,
            commodityGroupName: detail.commodityGroupName,
            isFromRebooking: true,
            sttNoRefExternal: detail.sttNoRefExternal,
            shcCode: detail.shcCode,
            shcName: detail.shcName,
            // Store cargoDimensionCustom only in the first index (index=0) of cargoDimensionCustom retry cargo. This is needed because when updating dimension v2 in modal change cargo type, the data is retrieved from the table data
            bagData: new CargoDetailBagData({
              bagCustomGrossWeight: detail.bagCustomGrossWeight,
              bagCustomVolumeWeight: detail.bagCustomVolumeWeight,
              bagGrossWeight: bagData?.grossWeight,
              bagCustomLength: bagData?.length,
              bagCustomWidth: bagData?.width,
              bagCustomHeight: bagData?.height
            }),
            sttPieces: this.getCargoDimensionCustom(detail),
            totalSttChargeableWeight: detail.totalSttChargeableWeight,
            chargeableWeight: detail.chargeableWeight,
            bagCustomChargeableWeight: detail.bagCustomChargeableWeight,
            sttClientId: detail.sttClientId
          })
        );
      });

      this.sttResult = newSttResult;

      await this.$nextTick();
      CargoController.setOnChangeTotalActualGrossWeight(
        this.dataDetailRetryCargo.cargoTotalCustomGrossWeight
      );
      CargoController.setOnChangeTotalCargoVolumeWeight(
        Math.round(this.dataDetailRetryCargo.cargoTotalCustomVolumeWeight)
      );

      CargoController.setCalculateType(this.dataDetailRetryCargo.calculateType);
      CargoController.setInitCalculateVolumeData(
        new CalculateVolume({
          chargeableWeight: this.dataDetailRetryCargo.currentChargeableWeight
        })
      );
    }
    CargoController.setDestinationCity(
      !this.$route.query.rcId ? "" : destinationParam
    );
  }

  resetBaggingGroupingAndDate() {
    CargoController.setShowNotesDestination(false);
    this.form.estDepartureDate = new Date(this.form.estDepartureDate);
  }

  mappingReadyToCargo() {
    CargoController.mappingReadyToCargo();
  }

  // commodity group
  isDisableCommodityGroup = false;

  get shcValue() {
    return this.form.shcCode && this.form.shcName
      ? `${this.form.shcCode} - ${this.form.shcName}`
      : "-";
  }

  get commodityOptions() {
    return CargoController.commodityOptions;
  }
  onSetCommodityGroup(isMounted = false) {
    this.enableCommodityGroup();

    const cargoCommodityData = new OptionsClass({
      name: this.form.cargoCommodityName,
      value: this.form.cargoCommodityCode,
      code: this.form.cargoCommodityCode,
      shcName: this.form.shcName,
      shcCode: this.form.shcCode
    });

    const mappingdata = this.mapSttDetails(this.sttResultFinal);
    const hasDG = mappingdata.some((item) => item.commodityGroupIsDg === true);

    const uniqueCommodityGroupsAll = this.filterUniqueCommodityGroups(
      mappingdata
    );
    const totalDataByCommodityGroupAll = this.countCommodityGroups(mappingdata);

    let selectedUnique = uniqueCommodityGroupsAll;
    let selectedMaxIndexLocation = this.findMaxIndexLocations(
      totalDataByCommodityGroupAll,
      this.findMaxCommodityGroup(totalDataByCommodityGroupAll)
    );

    if (hasDG) {
      const dgMapping = mappingdata.filter(
        (item) => item.commodityGroupIsDg === true
      );
      const uniqueCommodityGroupsDG = this.filterUniqueCommodityGroups(
        dgMapping
      );
      const totalDataByCommodityGroupDG = this.countCommodityGroups(dgMapping);

      const maxCommodityGroupDG = this.findMaxCommodityGroup(
        totalDataByCommodityGroupDG
      );
      const maxIndexLocationDG = this.findMaxIndexLocations(
        totalDataByCommodityGroupDG,
        maxCommodityGroupDG
      );

      selectedUnique = uniqueCommodityGroupsDG;
      selectedMaxIndexLocation = maxIndexLocationDG.length
        ? maxIndexLocationDG
        : selectedMaxIndexLocation;
    }

    this.setDominantCommodityGroup(selectedUnique, selectedMaxIndexLocation);
    this.updateFormWithCommodityItem();

    this.setCommodityOptions(uniqueCommodityGroupsAll);

    if (!isMounted) return;
    if (this.flowBooking === "rtc-edit") return;

    CargoController.setCommodityItem(cargoCommodityData);

    this.form.cargoCommodityCode = cargoCommodityData.value;
    this.form.cargoCommodityName = cargoCommodityData.name;
    this.form.shcName = cargoCommodityData.shcName;
    this.form.shcCode = cargoCommodityData.shcCode;
    this.setCargoComodity(cargoCommodityData);
  }

  enableCommodityGroup() {
    CargoController.setDisableCommodityGroup(false);
  }

  mapSttDetails(sttResultFinal: any[]): CargoDetailStt[] {
    const mappingdata: CargoDetailStt[] = [];
    for (const item of sttResultFinal) {
      if (item?.sttDetails?.length) {
        for (const detail of item.sttDetails) {
          mappingdata.push(detail);
        }
      } else {
        mappingdata.push(item);
      }
    }
    return mappingdata;
  }

  filterUniqueCommodityGroups(mappingdata: CargoDetailStt[]): CargoDetailStt[] {
    return uniqBy(
      mappingdata.filter((item: CargoDetailStt) => item.commodityGroupCode),
      "commodityGroupCode"
    );
  }

  countCommodityGroups(
    mappingdata: CargoDetailStt[]
  ): { name: string; total: number }[] {
    const countGroupByCommodity = mappingdata.reduce(
      (accumulator: any, item: CargoDetailStt) => {
        accumulator[item.commodityGroupName] =
          (accumulator[item.commodityGroupName] || 0) + 1;
        return accumulator;
      },
      {}
    );

    return Object.entries(countGroupByCommodity).map(([name, total]) => ({
      name,
      total: total as number
    }));
  }

  findMaxCommodityGroup(
    totalDataByCommodityGroup: { name: string; total: number }[]
  ): { name: string; total: number } {
    return totalDataByCommodityGroup.reduce(
      (prev, current) => (prev.total > current.total ? prev : current),
      { name: "", total: 0 }
    );
  }

  findMaxIndexLocations(
    totalDataByCommodityGroup: { name: string; total: number }[],
    max: { name: string; total: number }
  ): number[] {
    return totalDataByCommodityGroup.reduce(
      (accumulator, currentValue, currentIndex) =>
        currentValue.total === max.total
          ? accumulator.concat(currentIndex)
          : accumulator,
      [] as number[]
    );
  }

  setDominantCommodityGroup(
    uniqueCommodityGroups: CargoDetailStt[],
    maxIndexLocation: number[]
  ) {
    if (maxIndexLocation.length === 1) {
      this.handleSingleDominantCommodity(
        uniqueCommodityGroups,
        maxIndexLocation[0]
      );
    } else if (maxIndexLocation.length > 1) {
      this.handleMultipleDominantCommodities(
        uniqueCommodityGroups,
        maxIndexLocation[0]
      );
    }
  }

  handleSingleDominantCommodity(
    uniqueCommodityGroups: CargoDetailStt[],
    index: number
  ) {
    const dominantData = this.getDominantData(uniqueCommodityGroups, index);
    this.setCommodityItem(dominantData);
    this.updateFormWithDominantData(dominantData);
    CargoController.setDisableCommodityGroup(true);
  }

  handleMultipleDominantCommodities(
    uniqueCommodityGroups: CargoDetailStt[],
    index: number
  ) {
    const dominantData = this.getDominantData(uniqueCommodityGroups, index);
    this.setCommodityItem(dominantData);
    this.updateFormWithDominantData(dominantData);
  }

  getDominantData(
    uniqueCommodityGroups: CargoDetailStt[],
    index: number
  ): CargoDetailStt {
    return uniqueCommodityGroups[index];
  }

  setCommodityItem(dominantData: CargoDetailStt) {
    this.isDisableCommodityGroup = false;
    CargoController.setCommodityItem(
      new OptionsClass({
        name: dominantData?.commodityGroupName,
        code: dominantData?.commodityGroupCode,
        shcCode: dominantData?.shcCode,
        shcName: dominantData?.shcName
      })
    );
  }

  updateFormWithDominantData(dominanData: CargoDetailStt) {
    this.form.cargoCommodityName = dominanData?.commodityGroupName;
    this.form.cargoCommodityCode = dominanData?.commodityGroupCode || "";
    this.form.shcName = dominanData?.shcName || "";
    this.form.shcCode = dominanData?.shcCode || "";
    this.setCargoComodity(this.commodityItem);
  }

  updateFormWithCommodityItem() {
    if (this.commodityItem.name != "") {
      this.form.cargoCommodityName = this.commodityItem.name;
      this.form.cargoCommodityCode = this.commodityItem.name;
      this.form.shcName = this.commodityItem.shcName;
      this.form.shcCode = this.commodityItem.shcCode;
      this.setCargoComodity(this.commodityItem);
    }
  }

  setCommodityOptions(uniqueCommodityGroups: CargoDetailStt[]) {
    CargoController.setCommodityOptions(
      uniqueCommodityGroups.map(
        (item: CargoDetailStt) =>
          new OptionsClass({
            name: item.commodityGroupName,
            value: item.commodityGroupCode,
            shcCode: item.shcCode,
            shcName: item.shcName
          })
      )
    );
  }

  get disableCommodityGroup(): boolean {
    return CargoController.disableCommodityGroup;
  }
  get commodityItem() {
    return CargoController.commodityItem;
  }

  onSelectCommodity(val: any) {
    if (val.value === this.commodityItem.value) {
      CargoController.setCommodityItem({
        value: "",
        name: ""
      });
      this.form.cargoCommodityName = "";
      this.form.cargoCommodityCode = "";
      this.form.shcCode = "";
      this.form.shcName = "";
      return;
    }
    CargoController.setCommodityItem(val);
    this.form.cargoCommodityName = val.name;
    this.form.cargoCommodityCode = val.value;
    this.form.shcName = val.shcName;
    this.form.shcCode = val.shcCode;
    this.isCacheCommodityGroup = true;
    const comodity = new OptionsClass({
      name: val.name,
      value: val.value,
      shcCode: val.shcCode,
      shcName: val.shcName
    });
    this.setCargoComodity(comodity);
  }

  setCargoComodity(value: OptionsClass) {
    CargoController.setCargoComodity(value);
  }

  set isCacheCommodityGroup(value: boolean) {
    CargoController.setCacheCommodityGroup(value);
  }

  onChangeTotalCargoGrossWeight(value: any) {
    CargoController.setOnChangeTotalActualGrossWeight(value);
  }

  onChangeDimension(value: DimensionData) {
    CargoController.setIsChangeVolumeActual(false);
    CargoController.setOnChangeDimension(value);
  }

  onChangeTotalColi(value: number) {
    CargoController.setOnChangeTotalColi(value);
    this.actualTotalSTTPieces = value;
    CargoController.setTotalPcs(value);
    this.form.actualTotalSTTPieces = value;
    // CargoController.calculationVolumeWeight(this.totalPcs);
  }

  onChangeTotalCargoVolumeWeight(value: number) {
    CargoController.setIsChangeVolumeActual(true);
    CargoController.setOnChangeTotalCargoVolumeWeight(value);
  }

  set setEstimationTotalVolumeWeight(value: any) {
    CargoController.setEstimationTotalVolumeWeight(value);
  }

  set setEstimationTotalGrossWeight(value: any) {
    CargoController.setEstimationTotalGrossWeight(value);
  }

  async updateEstimationVolumeAndWeight() {
    this.setEstimationTotalVolumeWeight = this.totalVolumeWeights;
    this.setEstimationTotalGrossWeight = this.totalGrossWeights;
  }

  get isHaveBeenSubmitDetailPieces() {
    return CargoController.isHaveBeenSubmitDetailPieces;
  }

  get isErrorDiffPiecesActualThanDimensionPieces() {
    if (this.flagHideDimension) {
      return false;
    }
    return CargoController.isErrorDiffPiecesActualThanDimensionPieces;
  }

  private isPlaneCargo() {
    return this.form.cargoType === "plane";
  }

  private parseNumber(value: string) {
    if (typeof value === "number") return value;
    return value ? parseByCountry(value, { country: this.countryCode }) : 0;
  }

  get isErrorGrossWeight() {
    const weight = this.parseNumber(this.form.actualTotalCargoGrossWeight);
    const isError = this.isPlaneCargo() && weight > 400;
    CargoController.setErrorMaxGrossWeight(isError);
    return isError;
  }

  get isErrorVolumeWeight() {
    const volume = this.parseNumber(this.form.actualTotalCargoVolumeWeight);
    const isError = this.isPlaneCargo() && volume > 400;
    CargoController.setErrorMaxVolumeWeight(isError);
    return isError;
  }

  get isErrorMaxPieces() {
    const isError = this.isPlaneCargo() && this.form.actualTotalSTTPieces > 15;
    CargoController.setErrorMaxPieces(isError);
    return isError;
  }

  get isErrorWeightAdjustment() {
    const isError = CargoController.calculateVolumeData.isUploadProofPhoto;
    const showValidation =
      isError &&
      this.isValidationAdjustWeightProofPhotoEnable &&
      !this.loadingFirstLanding;
    if (!showValidation && !this.isRebooking) this.form.photoProof = [];
    if (this.isRebooking) {
      this.form.photoProof = showValidation ? this.rebookingTempPhotoProof : [];
    }
    return showValidation;
  }

  showPopupDimensionPieces(val: boolean) {
    CargoController.setShowPopupDimensionPieces(val);
    if (!this.isHaveBeenSubmitDetailPieces) {
      CargoController.formDetailPieces.totalPieces = this.totalPcs;
    }
  }

  get flagHideDimension() {
    return flags.feature_hide_dimension_koli.isEnabled();
  }

  get isCargoTrain() {
    return this.form.cargoType === "train";
  }

  get isCargoShip() {
    return this.form.cargoType === "ship";
  }

  get isCargoTruck() {
    return this.form.cargoType === "truck";
  }

  get isCargoPlaneManual() {
    return (
      this.form.cargoType === "plane" && this.form.cargoTypeStatus !== "auto"
    );
  }

  get isCargoPlaneAuto() {
    return (
      this.form.cargoType === "plane" && this.form.cargoTypeStatus === "auto"
    );
  }

  get isCargoPlane() {
    return this.form.cargoType === "plane";
  }

  isOpenSelectCargoProduct = false;

  async getCargoProductList() {
    try {
      await CargoController.getCargoProductList({
        status: "active"
      });
      if (!CargoController.cargoProductList.data.length) return;
      const foundData = CargoController.cargoProductList.data.find(
        (e: CargoProductData) =>
          e.cargoProductTypeCode === this.form.cargoProduct
      );
      if (!foundData) {
        CargoController.setOnSelectCargoProduct(
          CargoController.cargoProductList.data[0].cargoProductTypeCode
        );
      }
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          error,
          "Gagal mengambil data!",
          this.getCargoProductList
        )
      );
    }
  }

  get listProductCargo() {
    const defaultChoices: any = [
      {
        name: "Pilih Produk",
        value: "",
        status: ""
      }
    ];
    const cargos = CargoController.cargoProductList.data.map((e: any) => ({
      name: e.cargoProductTypeCode,
      value: e.cargoProductTypeCode,
      status: e.cargoProductTypeStatus
    }));

    return defaultChoices.concat(cargos);
  }

  onOpenSelectCargoProduct() {
    this.isOpenSelectCargoProduct = true;
  }

  onCloseSelectCargoProduct() {
    this.isOpenSelectCargoProduct = false;
  }

  onSelectCargoProduct(_: string, value: string) {
    this.onCloseSelectCargoProduct();
    CargoController.setOnSelectCargoProduct(value);
  }
  onChangeNog(value: string) {
    CargoController.setOnChangeNog(value);
  }

  onChangeVehicleNumber(value: string) {
    CargoController.setOnChangeVehicleNumber(value);
  }

  onChangeCargoNumber(value: string) {
    CargoController.setUpdateFromBookingCargoNumber(value);
  }

  get isRTC() {
    return (
      ReadyToCargoController.flowBooking.includes("rtc") ||
      (this.$route.query.rcId && this.flowBooking === "rebooking")
    );
  }

  get isFromRebookingRTC() {
    return (
      CargoController.isRebookingFromRTC && !this.flowBooking.includes("rtc")
    );
  }

  get isFillForm() {
    return CargoController.isFillForm;
  }

  get partnerName() {
    return this.dataProfile.account_type_detail.company_name;
  }

  get typeUser() {
    return this.dataProfile.normalizedTypeUser;
  }

  convertDecimal(value: string | number) {
    const num = typeof value === "string" ? parseByCountry(value, { country: this.countryCode }) : Number(value);
    return formatByCountry(num, { type: "weight", country: this.countryCode });
  }

  get errorAwb() {
    return NGenController.errorAwb;
  }

  get flightsData() {
    return CargoController.form.flightsData;
  }

  get vehicleNumber() {
    if (this.form.vehicleNumber && !this.isCargoPlaneAuto) {
      return this.form.vehicleNumber;
    }
    return this.isCargoPlaneManual
      ? this.form.vehicleNumber
      : this.flightsData
          .map((item: FlightDetail) => {
            return item.FlightNo;
          })
          .join(", ");
  }

  get showModalTest() {
    return CargoController.isShowModalGamification;
  }

  get showCommodityGroupPlane() {
    return (
      this.isCargoPlaneManual ||
      (this.isCargoPlaneAuto && this.isRTC) ||
      this.selectedCargoTypeV2BookingManual
    );
  }

  // edit dimension per koli
  get IS_EDIT_RTC(): boolean {
    return this.flowBooking === "rtc-edit";
  }
  updateDimensionPerKoliData() {
    // Extract total pieces and dimension pieces from CargoController
    const { dimensionPieces } = CargoController.dimensionPerKoliData;

    // Create a new data array by mapping over existing data
    const mappingKoliData = this.sttResultFinal.flatMap(
      (item: any) =>
        item.baggingNumber && this.hasBagDimensions(item.bagData)
          ? [this.createBagDimensionDetail(item)] // Create bag dimension details if dimensions exist
          : this.createPieceDimensionDetails(item) // Create piece dimension details otherwise
    );

    // Update dimension per koli details with existing and new data
    const updatedDimensionPerKoli: DimensionPerKoliDetail[] = mappingKoliData
      .map((newItem: DimensionPerKoliDetail) => {
        const existing = dimensionPieces.find(
          (item: DimensionPerKoliDetail) => item.sttOrBag === newItem.sttOrBag
        );
        return existing ? existing : newItem;
      })
      .filter(Boolean);

    // Set the updated dimension per koli data to CargoController
    if (!this.flagHideDimension) {
      CargoController.setDimensionPerKoliData(
        new DimensionPerKoliData({
          dimensionPieces: updatedDimensionPerKoli
        })
      );
    }
  }

  hasBagDimensions(bag: any): boolean {
    return !!(
      bag?.bagCustomLength &&
      bag?.bagCustomWidth &&
      bag?.bagCustomHeight
    );
  }
  private getBagId(item: any): string {
    return item.baggingVendorNo || item.baggingNumber;
  }

  private getBagDimensions(bagData: any) {
    return {
      length: bagData?.bagCustomLength,
      width: bagData?.bagCustomWidth,
      height: bagData?.bagCustomHeight,
      grossWeight: bagData?.bagCustomGrossWeight
    };
  }

  createBagDimensionDetail(item: any): DimensionPerKoliDetail {
    const bagDimensions = this.getBagDimensions(item.bagData);

    return new DimensionPerKoliDetail({
      sttOrBag: this.getBagId(item),
      sttPieceGrossWeight: bagDimensions.grossWeight,
      sttPieceVolumeWeight: this.calculateVolumeWeight(
        bagDimensions.length,
        bagDimensions.width,
        bagDimensions.height
      ),
      sttPieceLength: bagDimensions.length,
      sttPieceWidth: bagDimensions.width,
      sttPieceHeight: bagDimensions.height
    });
  }
  createPieceDimensionDetails(item: any) {
    return item?.sttPieces?.length
      ? item.sttPieces.map(
          (piece: CargoDetailSttPiece, index: number) =>
            new DimensionPerKoliDetail({
              sttOrBag: `${item.sttNumber} #${index + 1}`,
              sttPieceGrossWeight: piece.sttPieceGrossWeight,
              sttPieceVolumeWeight: this.calculateVolumeWeight(
                piece.sttPieceLength,
                piece.sttPieceWidth,
                piece.sttPieceHeight
              ),
              sttPieceLength: piece.sttPieceLength,
              sttPieceWidth: piece.sttPieceWidth,
              sttPieceHeight: piece.sttPieceHeight
            })
        )
      : [];
  }

  get minimumWeight() {
    return FlagsPermissionCargo.validation_3lc_cargo_minimum_weight.getValue();
  }
  get volumeWeightFlag() {
    return this.minimumWeight !== 0;
  }
  calculateVolumeWeight(length: number, width: number, height: number): number {
    const divider = getConfigDimensionDivider(this.form.cargoType);
    const volumeWeight = (length * width * height) / divider;
    return this.volumeWeightFlag
      ? volumeWeight < this.minimumWeight
        ? this.minimumWeight
        : volumeWeight
      : volumeWeight;
  }
  get dimensionPerKoliData(): DimensionPerKoliDetail[] {
    return CargoController.dimensionPerKoliData.dimensionPieces;
  }

  get showEditDimensionPerKoli(): boolean {
    return (
      !this.flagHideDimension &&
      (this.selectedCargoType ||
        this.isRtcShowDimensionV2 ||
        this.isRebookingShowDimensionV2)
    );
  }
  get isRebookingShowDimensionV2(): boolean {
    const validDimension = this.dimensionPerKoliData.every((e) => e.sttOrBag);
    return !!(this.isFromRebookingRTC
      ? this.dimensionPerKoliData?.length && validDimension
      : true);
  }

  get isRtcShowDimensionV2(): boolean {
    const validDimension = this.dimensionPerKoliData.every((e) => e.sttOrBag);
    return !!(this.flowBooking.includes("rtc") && !this.isFromRebookingRTC
      ? this.dimensionPerKoliData?.length && validDimension
      : true);
  }

  get showDimensionPerKoliV1() {
    const showDimensiPerKoli =
      !this.flagHideDimension &&
      (this.selectedCargoType ||
        this.isRtcShowDimensionV2 ||
        this.isRebookingShowDimensionV2);
    const showValidation =
      !this.selectedCargoType ||
      this.flagHideDimension ||
      !this.isRtcShowDimensionV2 ||
      !this.isRebookingShowDimensionV2;
    if (!showValidation) this.form.photoProof = [];
    if (!showValidation && showDimensiPerKoli)
      CargoController.setIsCargoDimensionOn(true);
    if (showValidation) CargoController.setIsCargoDimensionOn(false);
    return showValidation;
  }

  onUpdateLocalStorageRebooking() {
    if (this.isFromRebookingRTC || this.dataDetailRetryCargo.isUseSabre) {
      CargoController.setDimensionPerKoliData(
        new DimensionPerKoliData({
          dimensionPieces: this.cargoDimensionCustom
        })
      );
    }
  }

  get cargoDimensionCustom(): DimensionPerKoliDetail[] {
    return this.dataDetailRetryCargo.cargoDimensionCustom.map(
      (item: DimensionCustomData) =>
        new DimensionPerKoliDetail({
          sttOrBag: item.sttOrBag,
          sttPieceLength: item.length,
          sttPieceWidth: item.width,
          sttPieceHeight: item.height,
          sttPieceGrossWeight: item.grossWeight,
          sttPieceVolumeWeight: this.calculateVolumeWeight(
            item.length,
            item.width,
            item.height
          )
        })
    );
  }
  getCargoDimensionCustom(item: CargoDetailStt) {
    const identifiers = [
      item.baggingVendorNo,
      item.baggingNumber,
      item.sttNumber
    ].filter(Boolean); // Remove falsy values

    return this.cargoDimensionCustom.filter((dimension) =>
      identifiers.some((id) => dimension.sttOrBag.includes(id))
    );
  }

  get actualCargoVolumeWeight() {
    return this.getActualCargoWeight(
      CargoController.dimensionPerKoliData.actualVolumeWeight,
      this.form.actualTotalCargoVolumeWeight
    );
  }
  get actualCargoGrossWeight() {
    return this.getActualCargoWeight(
      CargoController.dimensionPerKoliData.actualGrossWeight,
      this.form.actualTotalCargoGrossWeight
    );
  }
  private getActualCargoWeight(dimensionWeight: number, totalWeight: string) {
    const isRtcOrRebooking = this.isRTC && this.form.cargoType === "plane";
    const dimensionsPlaneAuto =
      !flags.feature_hide_dimension_koli.isEnabled() &&
      this.isValidDimension &&
      (this.isPlaneAuto || isRtcOrRebooking);

    return dimensionsPlaneAuto && !this.isPlaneManualAwbValid
      ? formatByCountry(dimensionWeight, { type: "weight", country: this.countryCode })
      : commaDecimalToDecimal(totalWeight);
  }
  get isValidDimension(): boolean {
    return CargoController.dimensionPerKoliData.dimensionPieces.every(
      (e) => e.sttOrBag
    );
  }
  get isPlaneManualAwbValid() {
    return (
      CargoController.isAwbValid &&
      this.form.cargoType === "plane" &&
      this.form.cargoTypeStatus === "manual"
    );
  }

  get isValidAwb() {
    const { isValidAwb, isValidOriginOrDestination } = this.form;
    return isValidAwb && isValidOriginOrDestination;
  }

  get isValidationAdjustWeightProofPhotoEnable() {
    return (
      FlagsPermissionCargo.validation_adjust_weight_proof_photo_enable.isEnabled() &&
      (!this.isRebooking || this.cargoInputForm.isAllowUseProof)
    );
  }

  async onUploadAdjustmentWeight(params: UploadMultiple) {
    if (!params.file) return;

    MainAppController.closeMessageModal();
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();
    try {
      const fileLink = await BookingController.uploadHydraFile(
        new UploadHydraFileRequest({
          attachFile: params.file,
          folderPath: "stt/"
        })
      );
      this.form.photoProof[params.index] = fileLink.data;
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, this.$t("bookingShipment.error.uploadPhoto"))
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  async onRemoveAdjustmentWeight(index: number) {
    MainAppController.closeMessageModal();
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();
    try {
      const res = await BookingController.deleteHydraFile(
        new DeleteHydraFileRequest({
          attachFiles: [this.form.photoProof[index]]
        })
      );
      const statusDel = res.data[this.form.photoProof[index]];

      if (statusDel) {
        this.form.photoProof[index] = "";
      }
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, "Gagal menghapus Foto ke storage!")
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  async calculateVolume(calculateType = "", isScan = false) {
    await this.$nextTick();
    const isSttExist = !!this.sttResultFinal.length;
    CargoController.calculateVolume(
      new CalculateVolumeApiRequest({
        calculateType: !isSttExist ? "INIT" : calculateType,
        calculateRequest: new CalculateVolumeRequest({
          cargoType: this.form.cargoType,
          chargeableWeightReweigh: this.chargeableWeight,
          currentGrossWeight: this.parseNumber(
            this.form.actualTotalCargoGrossWeight
          ),
          height: this.form.actualDimension.height,
          length: isScan ? 90 : this.form.actualDimension.length,
          width: isScan ? 60 : this.form.actualDimension.width,
          totalPieces: this.form.actualTotalSTTPieces,
          volumeWeightReweigh: this.parseNumber(
            this.totalNewCalculationVolumeWeights as any
          ),
          divider: getConfigDimensionDivider(this.form.cargoType),
          isMinimumVolumePerPiece: getConfigIsminimumVolumePerPiece(
            this.form.cargoType,
            this.form.cargoTypeStatus
          ),
          minVolumePerPiece: getConfigMinimumVolumePerPiece(
            this.form.cargoType,
            this.form.cargoTypeStatus
          )
        })
      })
    );
  }

  async checkEligible() {
    await checkEligible(
      undefined,
      () => {
        if (!CargoController.sttResultFinal.length) {
          this.$emit("leave-page", "/cargo/booking-canceled");
        }
      },
      () => {
        this.isDeletedIneligible = true;
      }
    );
  }
}
